<div class="to-up" (click)="_toUp()" #up>
      <div class="icon">
          <i class="fa-solid fa-arrow-up"></i>
      </div>    
</div>    